Number.prototype.floorToNearest = function (nearest = 0.5) {
    const floor = Math.floor(this);
    const checkFloor = floor + nearest;
    return this > checkFloor ? checkFloor : floor;
};

Number.prototype.ceilToNearest = function (nearest = 0.5) {
    const ceil = Math.ceil(this);
    const checkCeil = ceil - nearest;
    return this < checkCeil ? checkCeil : ceil;
};

Number.prototype.formatNumber = function (n, x) {
    let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

Number.prototype.formatWithLabel = function (type, showSign, forceInteger) {
    return formatValue(this, type, showSign, forceInteger);
};

Number.prototype.niceNumber = function () {
    return niceNumber(this);
};

Number.prototype.niceIntNumber = function (noAbbreviation) {
    return niceIntNumber(this, noAbbreviation);
};

export function niceNumber(number, fractionDigits = 2) {
    if (typeof number === 'undefined') {
        return false;
    }
    number = parseFloat(number);
    let negative = false;
    if (number < 0) {
        negative = true;
        number = number * (-1);
    }

    if (number >= 1000000000000) {
        number = parseFloat(number / 1000000000000).toFixed(fractionDigits) * (negative ? (-1) : 1) + 't';
    } else if (number >= 1000000000) {
        number = parseFloat(number / 1000000000).toFixed(fractionDigits) * (negative ? (-1) : 1) + 'b';
    } else if (number > 1000000) {
        number = parseFloat(number / 1000000).toFixed(fractionDigits) * (negative ? (-1) : 1) + 'm';
    } else if (number > 1000) {
        number = parseFloat(number / 1000).toFixed(fractionDigits) * (negative ? (-1) : 1) + 'k';
    } else {
        number = number.toFixed(fractionDigits);
    }

    return number;
}

function niceIntNumber(number, noAbbreviation) {
    if (typeof number === 'undefined') {
        return false;
    }
    number = parseInt(number);

    let negative = false;
    if (number < 0) {
        negative = true;
        number = number * (-1);
    }

    if (noAbbreviation !== true) {
        if (number >= 1000000000000) {
            number = parseFloat(number / 1000000000000).formatNumber() * (negative ? (-1) : 1) + 't';
        } else if (number >= 1000000000) {
            number = parseFloat(number / 1000000000).formatNumber() * (negative ? (-1) : 1) + 'b';
        } else if (number >= 1000000) {
            number = parseFloat(number / 1000000).formatNumber() * (negative ? (-1) : 1) + 'm';
        } else if (number >= 1000) {
            number = parseFloat(number / 1000).formatNumber() * (negative ? (-1) : 1) + 'k';
        }
    } else {
        number = number.formatNumber();
    }

    return number;
}

/**
 *
 * @param value
 * @param valueType
 * @param showSign
 * @param forceInteger
 * @returns {*}
 */
export const formatValue = function(value, valueType, showSign, forceInteger) {
    let formattedValue;

    value = parseFloat(value);
    if (forceInteger) {
        value = parseInt(value);
    }

    if (value < 1 && valueType === 'percentage') {
        value = value * 100;
    }

    let isNegative = value < 0;

    value = value.formatNumber(2);

    switch (valueType) {
        case 'percentage':
            if (value === false) {
                formattedValue = '';
            } else {
                formattedValue = value + '%';
            }
            break;

        case 'currency':
            if (value === false) {
                formattedValue = '';
            } else {
                formattedValue = '$' + value;
                if (isNegative) {
                    formattedValue = '-$' + value.replace('-', '');
                }
            }
            break;

        case 'seconds':
            if (value === false) {
                formattedValue = '';
            } else {
                formattedValue = value + 's';
            }
            break;

        case 'minutes':
            if (value === false) {
                formattedValue = '';
            } else {
                formattedValue = value + 'min';
            }
            break;

        case 'hours':
            if (value === false) {
                formattedValue = '';
            } else {
                formattedValue = value + 'h';
            }
            break;

        case 'days':
            if (value === false) {
                formattedValue = '';
            } else {
                formattedValue = value + 'd';
            }
            break;

        case 'number':
            if (value === false) {
                formattedValue = '';
            } else {
                formattedValue = value;
            }
            break;

        default:
            if (value === false) {
                formattedValue = '';
            } else {
                formattedValue = value;
            }
            break;
    }

    if (forceInteger) {
        formattedValue = formattedValue.replace('.00', '');
    }

    if (isNegative && formattedValue.indexOf('-') === -1 && formattedValue !== '0') {
        return '-' + formattedValue;
    } else if (typeof showSign !== 'undefined' && showSign && !isNegative) {
        return '+' + formattedValue;
    }

    return formattedValue;
}
